module.exports = __webpack_public_path__ + "03f9d78b53f03e70338259892a475a0f.jpg";